import { alpha, styled } from '@mui/material/styles'
import { TableCell } from '@mui/material'

/* eslint-disable no-undef, no-unused-vars, no-empty-pattern */

export const TableGridRowStyledTableCell = styled(TableCell)(({ theme }) => ({
  whiteSpace: 'nowrap',
  padding: '0 0.8rem',
  '&:hover': {
    cursor: 'pointer',
  },
  '&:nth-last-of-type(-n+2)': {
    whiteSpace: 'unset',
  },
}))

export const TableGridRowCheckedStyledTableCell = styled(TableGridRowStyledTableCell)(({ theme }) => ({
  background: alpha(theme.palette.primary.light, 0.15),
}))

/* eslint-enable no-undef, no-unused-vars, no-empty-pattern */
